import AOS from "aos";
// You can also use <link> for styles
AOS.init({
  duration: 600,
  easing: "ease-out",
  once: true,
});
